import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import ProtectedRoute from './components/ProtectedRoute';
const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));

const JwtRegister = Loadable(lazy(() => import('app/views/sessions/JwtRegister')));
const ForgotPassword = Loadable(lazy(() => import('app/views/sessions/ForgotPassword')));
const ListProfilViews = Loadable(lazy(() => import('app/views/sessions/ListProfilViews')));
const EditProfile = Loadable(lazy(() => import('app/views/sessions/EditProfile')));

const ListStaff = Loadable(lazy(() => import('app/views/humanResources/ListStaff')));
const ListViewStaffById = Loadable(lazy(() => import('app/views/humanResources/ListViewStaffById')));
const ListCreateStaff = Loadable(lazy(() => import('app/views/humanResources/ListCreateStaff')));
const ListChangePassWord = Loadable(lazy(() => import('app/views/humanResources/ListChangePassWord')));

const ListRole = Loadable(lazy(() => import('app/views/permission/ListRole')));
const ListCreateRole = Loadable(lazy(() => import('app/views/permission/ListCreateRole')));
const ListPermission = Loadable(lazy(() => import('app/views/permission/ListPermission')));

const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));

const ListForgotPassword = Loadable(lazy(() => import('app/views/sessions/ListForgotPassword')));
const ListLogOut = Loadable(lazy(() => import('app/views/sessions/ListLogOut')));
const ListForgotPasswordNew = Loadable(lazy(() => import('app/views/sessions/ListForgotPasswordNew')));

const ListViewInvoice = Loadable(lazy(() => import('app/views/invoice/ListViewInvoice')));
const ListViewPrintInvoice = Loadable(lazy(() => import('app/views/invoice/ListViewPrintInvoice')));
const ListViewListInvoice = Loadable(lazy(() => import('app/views/invoice/ListViewListInvoice')));
const ListCreateInvoiceOBR = Loadable(lazy(() => import('app/views/invoice/ListCreateInvoice')));
const ListViewListInvoiceDetails = Loadable(lazy(() => import('app/views/invoice/ListViewListInvoiceDetails')));
const ListViewPrintInvoiceClient = Loadable(lazy(() => import('app/views/invoice/ListViewPrintInvoiceClient')));
const ListCreateInvoiceClient = Loadable(lazy(() => import('app/views/invoice/ListCreateInvoiceClient')));
const ListUpdateInvoiceProduit = Loadable(lazy(() => import('app/views/invoice/ListUpdateInvoiceProduit')));
const ListInvoiceCanceled = Loadable(lazy(() => import('app/views/invoice/ListInvoiceCanceled')));
const ListInvoiceNormal = Loadable(lazy(() => import('app/views/invoice/ListInvoiceNormal')));
const ListInvoiceEnAvoir = Loadable(lazy(() => import('app/views/invoice/ListInvoiceEnAvoir')));
const ListInvoiceProduit = Loadable(lazy(() => import('app/views/invoice/ListInvoiceProduit')));
const ListInvoiceNormalProduit = Loadable(lazy(() => import('app/views/invoice/ListInvoiceNormalProduit')));
const ListInvoiceEnAvoirProduit = Loadable(lazy(() => import('app/views/invoice/ListInvoiceEnAvoirProduit')));
const ListInvoiceCautionRefund = Loadable(lazy(() => import('app/views/invoice/ListInvoiceCautionRefund')));

const ListViewUnite = Loadable(lazy(() => import('app/views/unite/ListViewUnite')));
const ListCreateUnite = Loadable(lazy(() => import('app/views/unite/ListCreateUnite')));

const ListViewCategory = Loadable(lazy(() => import('app/views/category/ListViewCategory')));
const ListCreateCategory = Loadable(lazy(() => import('app/views/category/ListCreateCategory')));

const ListViewArticle = Loadable(lazy(() => import('app/views/article/ListViewArticle')));
const ListCreateArticle = Loadable(lazy(() => import('app/views/article/ListCreateArticle')));

const ListViewEntreprise = Loadable(lazy(() => import('app/views/entreprise/ListEntreprise')));
const ListCreateEntreprise = Loadable(lazy(() => import('app/views/entreprise/ListCreateEntreprise')));

const ListViewListStock = Loadable(lazy(() => import('app/views/stock/ListViewListStock')));
const ListCreateStock = Loadable(lazy(() => import('app/views/stock/ListCreateStock')));
const ListUpdateStock = Loadable(lazy(() => import('app/views/stock/ListUpdateStock')));

const ListCreateInvoiceService = Loadable(lazy(() => import('app/views/invoiceService/ListCreateInvoiceService')));
const ListPrintInvoiceService = Loadable(lazy(() => import('app/views/invoiceService/ListPrintInvoiceService')));
const ListPrintInvoiceServiceClient = Loadable(lazy(() => import('app/views/invoiceService/ListPrintInvoiceServiceClient')));
const ListCreateInvoiceServiceClient = Loadable(lazy(() => import('app/views/invoiceService/ListCreateInvoiceServiceClient')));
const ListUpdateInvoiceService = Loadable(lazy(() => import('app/views/invoiceService/ListUpdateInvoiceService')));
const ListPrintInvoiceProduitService = Loadable(lazy(() => import('app/views/invoiceService/ListPrintInvoiceProduitService')));
const ListInvoiceService = Loadable(lazy(() => import('app/views/invoiceService/ListInvoiceService')));
const ListInvoiceNormalService = Loadable(lazy(() => import('app/views/invoiceService/ListInvoiceNormalService')));
const ListInvoiceEnAvoirService = Loadable(lazy(() => import('app/views/invoiceService/ListInvoiceEnAvoirService')));

const ListClient = Loadable(lazy(() => import('app/views/client/ListClient')));
const ListCreateClient = Loadable(lazy(() => import('app/views/client/ListCreateClient')));

const ListSupplier = Loadable(lazy(() => import('app/views/supplier/ListSupplier')));
const ListCreateSupplier = Loadable(lazy(() => import('app/views/supplier/ListCreateSupplier')));

const ListPurchase = Loadable(lazy(() => import('app/views/purchase/ListPurchase')));
const ListCreatePurchase = Loadable(lazy(() => import('app/views/purchase/ListCreatePurchase')));
const ListPurchaseDetails = Loadable(lazy(() => import('app/views/purchase/ListPurchaseDetails')));
const ListCreatePurchaseImport = Loadable(lazy(() => import('app/views/purchase/ListCreatePurchaseImport')));

const ListEntrepriseByCode = Loadable(lazy(() => import('app/views/entreprise/ListEntrepriseByCode')));
const ListCreateEntrepriseTva = Loadable(lazy(() => import('app/views/entreprise/ListCreateEntrepriseTva')));
const ListUpdateEntreprise = Loadable(lazy(() => import('app/views/entreprise/ListUpdateEntreprise')));
const ListUpdateEntrepriseNifRc = Loadable(lazy(() => import('app/views/entreprise/ListUpdateEntrepriseNifRc')));
const ListEntrepriseLogo = Loadable(lazy(() => import('app/views/entreprise/ListEntrepriseLogo')));

const ListMovement = Loadable(lazy(() => import('app/views/movement/ListMovement')));
const ListMovementEntry = Loadable(lazy(() => import('app/views/movement/ListMovementEntry')));
const ListMovementOut = Loadable(lazy(() => import('app/views/movement/ListMovementOut')));
const ListViewMovementEntry = Loadable(lazy(() => import('app/views/movement/ListViewMovementEntry')));
const ListViewMovementOut = Loadable(lazy(() => import('app/views/movement/ListViewMovementOut')));

const ListCloseSell = Loadable(lazy(() => import('app/views/close/ListCloseSell')));
const ListCreateCloseSell = Loadable(lazy(() => import('app/views/close/ListCreateCloseSell')));

const ListCreateInvoiceCreditProduct = Loadable(lazy(() => import('app/views/invoiceCredit/ListCreateInvoiceCreditProduct')));
const ListCreateInvoiceCreditProductClient = Loadable(lazy(() => import('app/views/invoiceCredit/ListCreateInvoiceCreditProductClient')));
const ListCreateInvoiceCreditService = Loadable(lazy(() => import('app/views/invoiceCredit/ListCreateInvoiceCreditService')));
const ListCreateInvoiceCreditServiceClient = Loadable(lazy(() => import('app/views/invoiceCredit/ListCreateInvoiceCreditServiceClient')));
const ListInvoiceCredit = Loadable(lazy(() => import('app/views/invoiceCredit/ListInvoiceCredit')));
const ListInvoiceCreditProduit = Loadable(lazy(() => import('app/views/invoiceCredit/ListInvoiceCreditProduit')));
const ListInvoiceCreditService = Loadable(lazy(() => import('app/views/invoiceCredit/ListInvoiceCreditService')));

const ListInvoiceRefund = Loadable(lazy(() => import('app/views/invoiceRefund/ListInvoiceRefund')));
const ListInvoiceRefundProduit = Loadable(lazy(() => import('app/views/invoiceRefund/ListInvoiceRefundProduit')));
const ListInvoiceRefundService = Loadable(lazy(() => import('app/views/invoiceRefund/ListInvoiceRefundService')));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      { path: "/dashboard", element: <Analytics />, auth: authRoles.admin },
      { path: "/view-close-sell", 
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CLOTURE:AFFICHAGE"]}>
            <ListCloseSell />
           </ProtectedRoute>
        ),auth: authRoles.admin },
      { path: "/create-close-sell", 
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CLOTURE:CREATION"]}>
            <ListCreateCloseSell />
           </ProtectedRoute>
        ), auth: authRoles.admin },
      {
        path: "/create-caution-refund",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListInvoiceCautionRefund />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-invoice-caution-refund",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceRefund />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-invoice-caution-refund-produit",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceRefundProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-invoice-caution-refund-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceRefundService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-invoice-credit",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceCredit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-invoice-credit-produit",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceCreditProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-invoice-credit-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceCreditService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/create-invoice-credit",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceCreditProduct />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/create-invoice-credit-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceCreditProductClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/create-invoice-credit-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceCreditService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/create-invoice-service-credit-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceCreditServiceClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
       {
        path: "/view-movement",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "MOUVEMENT:AFFICHAGE"]}>
            <ListMovement />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-entry-movement",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "MOUVEMENT:AFFICHAGE"]}>
            <ListViewMovementEntry />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-out-movement",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "MOUVEMENT:AFFICHAGE"]}>
            <ListViewMovementOut />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/create-entry-movement",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "MOUVEMENT:CREATION"]}>
            <ListMovementEntry />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/create-out-movement",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "MOUVEMENT:CREATION"]}>
            <ListMovementOut />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-purchase-details/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "PURCHASE:DETAIL"]}>
            <ListPurchaseDetails />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-purchase",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ACHAT:AFFICHAGE"]}>
            <ListPurchase />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/create-purchase",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ACHAT:CREATION"]}>
            <ListCreatePurchase />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
            
      {
        path: "/create-purchase-import",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ACHAT:CREATION"]}>
            <ListCreatePurchaseImport />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/view-supplier",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FOURNISSEUR:AFFICHAGE"]}>
            <ListSupplier />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/create-supplier",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FOURNISSEUR:CREATION"]}>
            <ListCreateSupplier />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/view-consumer",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CLIENT:AFFICHAGE"]}>
            <ListClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/create-consumer",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CLIENT:CREATION"]}>
            <ListCreateClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/create-invoice-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },            
      {
        path: "/create-invoice-service-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceServiceClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-invoice-print/:id/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:IMPRESSION"]}>
            <ListPrintInvoiceProduitService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-print-invoice-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListPrintInvoiceService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      }, 
                      
      {
        path: "/view-invoice-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },               
      {
        path: "/view-print-invoice-service-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListPrintInvoiceServiceClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/update-invoice-obr/:id/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:MODIFICATION"]}>
            <ListUpdateInvoiceService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-stock",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "STOCK:AFFICHAGE"]}>
            <ListViewListStock />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-stock",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "STOCK:CREATION"]}>
            <ListCreateStock />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/update-stock",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "STOCK:MODIFICATION"]}>
            <ListUpdateStock />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/forgotpassword",
        element: <ListForgotPassword />,
        auth: authRoles.admin,
      },
      { path: "/logout", element: <ListLogOut />, auth: authRoles.admin },
      {
        path: "/newpassword",
        element: <ListForgotPasswordNew />,
        auth: authRoles.admin,
      },
      {
        path: "/forget-password",
        element: <ListChangePassWord />,
        auth: authRoles.admin,
      },                      
      {
        path: "/view-user",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "UTILISATEUR:AFFICHAGE"]}>
            <ListStaff />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-staffById/:id",
        element: <ListViewStaffById />,
        auth: authRoles.admin,
      },                
      {
        path: "/create-user",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "UTILISATEUR:CREATION"]}>
            <ListCreateStaff />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-role",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ROLE:AFFICHAGE"]}>
            <ListRole />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-role",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ROLE:CREATION"]}>
            <ListCreateRole />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
                      
      {
        path: "/view-role-by-id/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ROLE:MODIFICATION"]}>
            <ListPermission />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      { path: "/page-layouts/user-profile", element: <ListProfilViews /> },               
      {
        path: "/view-invoice-obr/:id/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:DETAIL"]}>
            <ListViewInvoice />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-print-invoice",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListViewPrintInvoice />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
      {
        path: "/view-print-invoice-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListViewPrintInvoiceClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-list-invoice",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListViewListInvoice />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-invoice-canceled",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceCanceled />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },      
      {
        path: "/view-invoice-in-have",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceEnAvoir />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },       
      {
        path: "/view-invoice-in-have-product",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceEnAvoirProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },       
      {
        path: "/view-invoice-in-have-service",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceEnAvoirService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },     
      {
        path: "/view-invoice-normal",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceNormal />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },       
      {
        path: "/view-invoice-produit-normal",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceNormalProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
             
      {
        path: "/view-invoice-service-normal",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceNormalService />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },               
      {
        path: "/view-list-invoice-produit/:id/:id",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:MODIFICATION"]}>
            <ListUpdateInvoiceProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-invoice-obr",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceOBR />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-invoice-obr-client",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:CREATION"]}>
            <ListCreateInvoiceClient />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-list-invoice-details",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:DETAIL"]}>
            <ListViewListInvoiceDetails />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-unite",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "UNITE:AFFICHAGE"]}>
            <ListViewUnite />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-unite",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "UNITE:CREATION"]}>
            <ListCreateUnite />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-category",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CATEGORIE:AFFICHAGE"]}>
            <ListViewCategory />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/create-category",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "CATEGORIE:CREATION"]}>
            <ListCreateCategory />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                
      {
        path: "/view-article",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "PRODUIT:AFFICHAGE"]}>
            <ListViewArticle />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                         
      {
        path: "/view-invoice-produit",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "FACTURE:AFFICHAGE"]}>
            <ListInvoiceProduit />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },               
      {
        path: "/create-article",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "PRODUIT:CREATION"]}>
            <ListCreateArticle />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },              
      {
        path: "/view-enterprise",
        element: (
           <ProtectedRoute permissions={["ADMIN"]}>
            <ListViewEntreprise />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },              
      {
        path: "/create-enterprise",
        element: (
           <ProtectedRoute permissions={["ADMIN"]}>
            <ListCreateEntreprise />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },              
      {
        path: "/view-enterprise-by-code",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ENTREPRISE:AFFICHAGE"]}>
            <ListEntrepriseByCode />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },              
      {
        path: "/update-enterprise",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ENTREPRISE:MODIFICATION"]}>
            <ListUpdateEntreprise />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },              
      {
        path: "/update-nif-rc-enterprise",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ENTREPRISE:MODIFICATION"]}>
            <ListUpdateEntrepriseNifRc />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },               
      {
        path: "/add-logo-enterprise",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ENTREPRISE:MODIFICATION"]}>
            <ListEntrepriseLogo />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },                   
      {
        path: "/create-enterprise-by-tva",
        element: (
           <ProtectedRoute permissions={["TOUT:TOUT", "ENTREPRISE:MODIFICATION"]}>
            <ListCreateEntrepriseTva />
           </ProtectedRoute>
        ),
        auth: authRoles.admin,
      },
    ],
  },

  { path: "/session/404", element: <NotFound /> },
  { path: "/session/sign-in", element: <JwtLogin /> },
  // { path: '/session/sign-in-after', element: <AfterLogin /> },
  { path: "/", element: <Navigate to="session/sign-in" /> },
  { path: "/session/signup", element: <JwtRegister /> },
  { path: "/session/forgot-password", element: <ForgotPassword /> },
  { path: "/page-layouts/edit-profile", element: <EditProfile /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
